export const ContactPersonsHelper = {
    getInvalidContactPersons(contactPersons) {
        const idx = [];
        contactPersons.forEach((cp, index) => {
            if ((cp.is_default_billing || cp.is_default_shipping) &&
                !(cp.first_name || cp.last_name)
            )
                idx.push(index);
        });

        return idx;
    },

    normalizeContactPersonsData(initialData, currentData) {
        // if billing/shipping cp is the same (but not null), set initial cp name as null to avoid triggering isModified
        const newInitialData = {...initialData};
        if (initialData.billing_contact_person_id &&
            initialData.billing_contact_person_id === currentData.billing_contact_person_id)
            newInitialData.billing_contact_person = null;
        if (initialData.shipping_contact_person_id &&
            initialData.shipping_contact_person_id === currentData.shipping_contact_person_id)
            newInitialData.shipping_contact_person = null;

        return {...newInitialData};
    },
};
